import { FormattedNumber } from 'i18n'

const shouldShowValueInSmall = value => value >= 10

const MarkerRateCounter = ({ opngo, rate, canBuy }) => {
    const rateClassName = rate && shouldShowValueInSmall(rate.amount) ? 'small' : ''

    return (
        canBuy &&
        rate &&
        !opngo && (
            <span className={rateClassName}>
                <FormattedNumber
                    value={rate.amount}
                    style={'currency'}
                    currency={rate.currency}
                    minimumFractionDigits={rate.fractionDigits}
                    maximumFractionDigits={rate.fractionDigits}
                />
            </span>
        )
    )
}

export default MarkerRateCounter
